export default __webpack_public_path__ + "static/media/materialui-svg.5b2d8a0a.png";